import { Component, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: "confirm-delete",
  templateUrl: "./users-search-params.component.html",
  styleUrls: ["./users-search-params.component.css"]
})
export class SearchParams {
  @Input() public departments;
  @Input() public searchState;
  @Input() public positions;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  myForm: FormGroup;
  searchParams = {
    limit: 10,
    offset: 1,
    status: [],
    language: [],
    searchFilter: "",
    dateRange: {
      startDate: "",
      endDate: ""
    },
    roles: [],
    departments: [],
    positions: []
  };
  loadState = false;
  searchTextDepartments;
  searchTextPositions;

  minDateForTo: any; 
  maxDateForFrom: any; 

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.myForm = new FormGroup({
      dateFrom: new FormControl(),
      dateTo: new FormControl()
    });
    if (this.searchState) {
      this.searchParams = { ...this.searchState };
      this.searchParams.dateRange.startDate = "";
      this.searchParams.dateRange.endDate = "";
      this.loadState = true;
    }

    this.myForm.controls.dateFrom.valueChanges.subscribe((value) => {
      this.updateMinDateForTo(value); // Обновляем минимальную дату для dateTo
    });
    this.myForm.controls.dateTo.valueChanges.subscribe((value) => {
      this.updateMaxDateForFrom(value); // Обновляем максимальную дату для dateFrom
    });

    this.loadState = true;
  }

  updateMinDateForTo(dateFromValue: any) {
    if (dateFromValue) {
      this.minDateForTo = { year: dateFromValue.year, month: dateFromValue.month, day: dateFromValue.day };
    } else {
      this.minDateForTo = null; // Сброс минимальной даты, если дата "От" очищена
    }
  }

  // Метод для обновления максимальной даты для dateFrom
  updateMaxDateForFrom(dateToValue: any) {
    if (dateToValue) {
      this.maxDateForFrom = { year: dateToValue.year, month: dateToValue.month, day: dateToValue.day };
    } else {
      this.maxDateForFrom = null; // Сброс максимальной даты, если дата "До" очищена
    }
  }

  onCheckParam(event, param) {
    if (event.target.checked) {
      this.searchParams[param].push(event.target.defaultValue);
    } else {
      const index = this.searchParams[param].indexOf(event.target.defaultValue);
      if (index > -1) {
        this.searchParams[param].splice(index, 1);
      }
    }
  }

  isCheckedParam(param, field) {
    if (this.searchParams) {
      if (~this.searchParams[field].indexOf(param)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  validateDateRange() {
    const dateFromValue = this.myForm.controls.dateFrom.value;
    const dateToValue = this.myForm.controls.dateTo.value;

    if (dateFromValue && dateToValue) {
      const startDate = new Date(dateFromValue.year, dateFromValue.month - 1, dateFromValue.day);
      const endDate = new Date(dateToValue.year, dateToValue.month - 1, dateToValue.day);

      if (endDate < startDate) {
        this.myForm.controls.dateTo.setErrors({ dateRangeInvalid: true });
        this.myForm.controls.dateFrom.setErrors({ dateRangeInvalid: true });
      } else {
        this.myForm.controls.dateTo.setErrors(null);
        this.myForm.controls.dateFrom.setErrors(null);
      }
    }
  }

  onCheckChange(event) {
    switch (event.target.name) {
      case "status":
        if (event.target.checked) {
          this.searchParams.status.push(event.target.defaultValue);
        } else {
          const index = this.searchParams.status.indexOf(
            event.target.defaultValue
          );
          if (index > -1) {
            this.searchParams.status.splice(index, 1);
          }
        }
        break;
      case "roles":
        if (event.target.checked) {
          this.searchParams.roles.push(event.target.defaultValue);
        } else {
          const index = this.searchParams.roles.indexOf(
            event.target.defaultValue
          );
          if (index > -1) {
            this.searchParams.roles.splice(index, 1);
          }
        }
        break;
      case "language":
        if (event.target.checked) {
          this.searchParams.language.push(event.target.defaultValue);
        } else {
          const index = this.searchParams.language.indexOf(
            event.target.defaultValue
          );
          if (index > -1) {
            this.searchParams.language.splice(index, 1);
          }
        }
        break;
    }
  }

  isSelectedParams(id, field) {
    if (
      this.searchState &&
      this.searchState[field] &&
      this.searchState[field].length !== 0
    ) {
      if (~this.searchState[field].indexOf(id)) {
        return true;
      }
    } else {
      return false;
    }
  }

  handleFormSubmit() {

    this.validateDateRange();
    if (
      this.myForm.controls.dateFrom.value &&
      this.myForm.controls.dateTo.value
    ) {
      let dayFrom = this.myForm.controls.dateFrom.value.day;
      let dayTo = this.myForm.controls.dateTo.value.day;
      let monthFrom = this.myForm.controls.dateFrom.value.month;
      let monthTo = this.myForm.controls.dateTo.value.month;

      if (dayFrom < 10) {
        dayFrom = "0" + dayFrom;
      }
      if (dayTo < 10) {
        dayTo = "0" + dayTo;
      }
      if (monthFrom < 10) {
        monthFrom = "0" + monthFrom;
      }
      if (monthTo < 10) {
        monthTo = "0" + monthTo;
      }

      const startDate =
        "" +
        this.myForm.controls.dateFrom.value.year +
        "-" +
        monthFrom +
        "-" +
        dayFrom;
      const endDate =
        "" +
        this.myForm.controls.dateTo.value.year +
        "-" +
        monthTo +
        "-" +
        dayTo;
      this.searchParams.dateRange.startDate = startDate;
      this.searchParams.dateRange.endDate = endDate;
    } else {
      this.searchParams.dateRange.startDate = "";
      this.searchParams.dateRange.endDate = "";
    }

    this.passEntry.emit(this.searchParams);
    this.activeModal.close(this.searchParams);
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/modals/users-search-params/users-search-params.component.ts